// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/" + chunkId + ".tdfx-9.5.4-SNAPSHOT.js";
};